// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const drilbur: PokeData = {
  "id": 529,
  "name": "drilbur",
  "height": 3,
  "weight": 85,
  "base_experience": 66,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [
    "scratch",
    "swords-dance",
    "earthquake",
    "fissure",
    "dig",
    "fury-swipes",
    "rock-slide",
    "slash",
    "mud-slap",
    "sandstorm",
    "rapid-spin",
    "metal-claw",
    "mud-sport",
    "crush-claw",
    "hone-claws",
    "drill-run"
  ],
  "moves": [
    "scratch",
    "earthquake",
    "fissure",
    "rock-slide",
    "mud-slap",
    "sandstorm",
    "metal-claw",
    "bone-throw",
    "mud-bomb",
    "magnitude",
    "mud-shot",
    "bonemerang",
    "earth-power"
  ],
  "evolution_chain": {
    "id": 270,
    "item": null,
    "species": [
      {
        "name": "drilbur",
        "order": 530,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "excadrill",
        "order": 531,
        "types": [
          PokeType.GROUND,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 529,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 31,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 51.25,
    "speed": 68,
    "ability_power": 85
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
